import { render } from "./Passings.vue?vue&type=template&id=cf7784f4&scoped=true"
import script from "./Passings.vue?vue&type=script&lang=js"
export * from "./Passings.vue?vue&type=script&lang=js"

import "./Passings.vue?vue&type=style&index=0&id=cf7784f4&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7784f4"]])

export default __exports__